// OffersHub (admin) — Routing Restructure (2026-05-16).
//
// Renamed from RewardsHub; the URL prefix is `/offers/*`.
//
// Tabs (left to right by money-flow logic):
//
//   /offers/list      → OffersListPanel       (catalog of offers)
//   /offers/claims    → ClaimsQueuePanel      (admin approval queue)
//   /offers/bulk-pay  → BulkPayoutsPanel      (ad-hoc mass credit;
//                                              moved here from
//                                              /people/players/bulk)
//   /offers/referrals → ReferralsPanel        (player-to-player
//                                              referral payouts; moved
//                                              here from /people/players/
//                                              referrals)
//
// Detail / new offer routes (/offers/new, /offers/:id) are SIBLING
// pages, mounted in App.tsx outside this hub's Outlet — same pattern
// as the old `/rewards/offers/new` and `/rewards/offers/:id`. The
// reserved tab paths (`list`, `claims`, `bulk-pay`, `referrals`) take
// precedence over `:id` because of React Router exact-match priority.

import TabHub, { type TabDef } from '@baaligames/shared-ui/admin/components/TabHub';

const TABS: TabDef[] = [
  { to: '/offers/list',      label: 'Offers',    icon: 'redeem',       matchPrefix: '/offers/list' },
  { to: '/offers/claims',    label: 'Claims',    icon: 'how_to_reg',   matchPrefix: '/offers/claims' },
  { to: '/offers/bulk-pay',  label: 'Bulk Pay',  icon: 'inventory_2',  matchPrefix: '/offers/bulk-pay' },
  { to: '/offers/referrals', label: 'Referrals', icon: 'share',        matchPrefix: '/offers/referrals' },
];

export default function OffersHub() {
  return (
    <TabHub
      title="Offers"
      titleIcon="card_giftcard"
      subtitle="Offers · claims · bulk pay · referrals — every player payout in one place"
      tabs={TABS}
    />
  );
}
